import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FinancialScoreCardsWrapper } from './ui/financial-score-cards';

const proofsData = [
  {
    title: "Firma deweloperska - Doradztwo",
    description: "35h tygodniowo oszczędności na manualnych zadaniach. Automatyczny pipeline leadów z LinkedIn prosto do CRM.",
    initialScore: 35,
    maxScore: 40,
    suffix: "h/tydz",
    detailUrl: "/blog/voice-agent-case-study-deweloperka"
  },
  {
    title: "Kognita - Edukacja VR",
    description: "Ok. 2 tys. spersonalizowanych cold maili wygenerowanych automatycznie z bazy szkół i pipeline'u video AI. 2 pozyskanych klientów, kilkukrotny ROI.",
    initialScore: 2000,
    maxScore: 2500,
    suffix: "maili",
    valuePlus: true,
    detailUrl: "/blog"
  },
  {
    title: "E-commerce - PL/DE",
    description: "95% ticketów obsługiwanych automatycznie. 1 osoba w CS obsługuje 1 200 zgłoszeń miesięcznie dzięki inteligentnej bazie wiedzy (RAG).",
    initialScore: 95,
    maxScore: 100,
    suffix: "% automat.",
    detailUrl: "/blog/ecom-rag-customer-support"
  }
];

export default function SystemProof() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="raporty" aria-label="Raporty z systemów" className="py-16 md:py-24 bg-bg dark">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16">
        
        {/* Header */}
        <motion.div
          className="mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="w-8 h-px bg-stroke"></div>
            <span className="text-xs text-muted uppercase tracking-[0.3em]">Raporty z systemów</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl tracking-tight font-light text-text-primary mb-4">
            Surowe dane <span className="font-display italic">z produkcji</span>
          </h2>
          <p className="text-muted max-w-sm">Wdrażamy systemy, mierzymy wyniki, skalujemy operacje.</p>
        </motion.div>

        {/* Cards Wrapper */}
        <div ref={ref}>
          <FinancialScoreCardsWrapper data={proofsData} />
        </div>

      </div>
    </section>
  );
}
